import { render, staticRenderFns } from "./DataIncomeStatistic.vue?vue&type=template&id=7aa092aa&scoped=true"
import script from "./DataIncomeStatistic.vue?vue&type=script&lang=js"
export * from "./DataIncomeStatistic.vue?vue&type=script&lang=js"
import style0 from "./DataIncomeStatistic.vue?vue&type=style&index=0&id=7aa092aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa092aa",
  null
  
)

export default component.exports